/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./multi-game-difficulty.vue?vue&type=template&id=5e1351f6&scoped=true&"
import script from "./multi-game-difficulty.vue?vue&type=script&lang=js&"
export * from "./multi-game-difficulty.vue?vue&type=script&lang=js&"
import style0 from "./multi-game-difficulty.vue?vue&type=style&index=0&id=5e1351f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1351f6",
  null
  
)

export default component.exports